import { Button, Typography, makeStyles } from '@material-ui/core';
import React from 'react';
import RoadDiversion from '../../assets/icons/diversion-road.svg';

const { REACT_APP_CONSOLE_REDIRECTION_URL } = process.env;

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const FeatureOffset = () => {
  const classes = useStyles();
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        textAlign: 'center',
        flexDirection: 'column',
        marginTop: 20,
      }}
    >
      <img
        src={RoadDiversion}
        alt="diversion"
        style={{ width: '280px', marginBottom: 50 }}
      />
      <Typography variant="body1">
        🔍 Feature Moved! <br /> We&#39;ve moved this feature to Console. You
        can now access it in Console.
        <br /> We apologize for any inconvenience caused.
      </Typography>
      <Button
        onClick={() => {
          const path = window.location.pathname;

          if (path.includes('branches')) {
            window.open(
              `${REACT_APP_CONSOLE_REDIRECTION_URL}/dashboard/branches`,
              '_blank'
            );
          } else if (path.includes('truckers')) {
            window.open(
              `${REACT_APP_CONSOLE_REDIRECTION_URL}/dashboard/add-trucker`,
              '_blank'
            );
          } else if (path.includes('approve/transporter')) {
            window.open(
              `${REACT_APP_CONSOLE_REDIRECTION_URL}/dashboard/approvals/transporter-approval`,
              '_blank'
            );
          } else if (path.includes('transporters')) {
            window.open(
              `${REACT_APP_CONSOLE_REDIRECTION_URL}/dashboard/transporter`,
              '_blank'
            );
          } else {
            window.open(REACT_APP_CONSOLE_REDIRECTION_URL, '_blank');
          }
        }}
        variant="contained"
        color="primary"
        style={{ marginTop: 20 }}
      >
        Visit Console
      </Button>
    </div>
  );
};

export default FeatureOffset;
